import {UseMutationOptions, useMutation} from '@tanstack/react-query';
import {
  FastAPIServiceError,
  UserFinalizeResponse,
  UserInitiatePayload,
} from '@guestapp/sdk';
import {useIsMounted} from '../common';
import {useChekinSDK} from 'context/ChekinSDK';

type Props = UseMutationOptions<
  UserFinalizeResponse,
  FastAPIServiceError,
  UserInitiatePayload
>;
function useGuestAccountTokenMutation({onError, ...props}: Props = {}) {
  const {getGuestAccountToken} = useChekinSDK();

  const isMounted = useIsMounted();

  return useMutation<UserFinalizeResponse, FastAPIServiceError, UserInitiatePayload>(
    payload => getGuestAccountToken(payload),
    {
      ...props,
      onError: (error, data, variables) => {
        if (!isMounted.current) {
          return;
        }

        onError?.(error, data, variables);
      },
      ...props,
    },
  );
}

export {useGuestAccountTokenMutation};
